import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'

import * as DoorAccessActionCreators from '../../actions/doorAccess'
import DoorAccessFormik from './DoorAccessFormik'

const DEFAULT_DOOR_ACCESS = {
  name: '',
  credentials: [],
  enabled: true,
  parent_community_id: 0,
}

class DoorAccessFormDialogContainer extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    history: PropTypes.object.isRequired,
    /* passed props */
    accessId: PropTypes.number,
    communityId: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    name: PropTypes.string, // when creating a new user, name can be pre-populated
    open: PropTypes.bool.isRequired,
    unitId: PropTypes.number, // when creating a new user and adding them to a unit
    /* mapped state */
    doorAccesses: PropTypes.object.isRequired,
    /* mapped dispatch */
    doorAccessActions: PropTypes.object.isRequired,
  }

  static defaultProps = {
    accessId: 0,
    name: '',
    unitId: null,
  }

  static mapStateToProps(state) {
    return {
      doorAccesses: state.doorAccesses,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      doorAccessActions: bindActionCreators(DoorAccessActionCreators, dispatch),
    }
  }

  handleSave = (user) => {
    if (user.id) {
      this.props.doorAccessActions.saveDoorAccess(user)
    } else {
      this.props.doorAccessActions.addDoorAccess(user, this.props.unitId)
    }
    this.handleClose()
  }

  handleClose = () => {
    this.props.onClose()
  }

  handleDelete = () => {
    this.props.doorAccessActions.removeDoorAccesses(
      this.props.communityId,
      [this.props.accessId],
    )
    this.handleClose()
    this.props.history.push(`/communities/${this.props.communityId}`)
  }

  getDoorAccess = () => {
    const { doorAccesses, accessId } = this.props

    if (accessId && doorAccesses[accessId]) {
      return doorAccesses[accessId]
    }

    const doorAccess = { ...DEFAULT_DOOR_ACCESS }
    doorAccess.name = this.props.name
    doorAccess.parent_community_id = this.props.communityId
    return doorAccess
  }

  render() {
    const doorAccess = this.getDoorAccess()

    return (
      <Dialog open={this.props.open} onClose={this.handleClose}>
        <DialogTitle>
          {doorAccess.id ? `Edit Door Access User ${doorAccess.id}` : 'Create Door Access User'}
        </DialogTitle>
        <DialogContent>
          <DoorAccessFormik
            doorAccess={doorAccess}
            onSave={this.handleSave}
            onEditCancel={this.handleClose}
            onDelete={this.handleDelete}
          />
        </DialogContent>
      </Dialog>
    )
  }
}

export default connect(
  DoorAccessFormDialogContainer.mapStateToProps,
  DoorAccessFormDialogContainer.mapDispatchToProps,
)(withRouter(DoorAccessFormDialogContainer))
